module.exports = __webpack_public_path__ + "img/image2.0ff6fb34.jpeg";